import * as Headless from "@headlessui/react";
import clsx from "clsx";
import { ReactElement } from "react";

export const DropdownSection = ({
  className,
  ...props
}: { className?: string } & Omit<
  Headless.MenuSectionProps,
  "as" | "className"
>): ReactElement => (
  <Headless.MenuSection
    {...props}
    className={clsx(
      className,
      // Define grid at the section level instead of the item level if subgrid is supported
      "col-span-full supports-[grid-template-columns:subgrid]:grid supports-[grid-template-columns:subgrid]:grid-cols-[auto_1fr_1.5rem_0.5rem_auto]",
    )}
  />
);
